import { Component, OnInit, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { SliderCvComponent } from '../slider-cv/slider-cv.component';
import { FreelancerFilter } from '../interfaces/filters';
import { FreelancerStore } from '../state/freelancer.store';
import { Observable } from 'rxjs/Observable';
import { FreelancerService } from '../services/freelancer.service';
// import { JobSelectorDialogComponent } from '../job-selector-dialog/job-selector-dialog.component'
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Freelancer } from '../models/freelancer';
// import { MessageBoxInviteDialog } from '../message-box-invite/message-box-invite.component';

@Component({
  selector: 'app-list-freelancers',
  templateUrl: './list-freelancers.component.html',
  styleUrls: ['./list-freelancers.component.css']
})
export class ListFreelancersComponent implements OnInit {

  @Input() freelancerAsigned: boolean;
  @Input() freelancerFilter: FreelancerFilter;
  @Input() requirement: boolean;
  @Output() refreshFreelancerList: EventEmitter<boolean> = new EventEmitter<boolean>();

  maxCandidates: number;
  errorMessage: string;
  loading: Observable<boolean>;
  size: Observable<number>;
  total: Observable<number>;

  constructor(private dialog: MatDialog,
              public freelancerStore: FreelancerStore,
              private freelancerService: FreelancerService) {
    this.maxCandidates = 10;
    this.requirement = true;

    this.loading = this.freelancerStore.loading.share();
    this.size = this.freelancerStore.freelancers.map((freelancers: Freelancer[]) => freelancers.length);
    this.total = this.freelancerStore.getTotal;
  }

  ngOnInit() {
    this.refreshListing(1);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.refreshListing(1);
  }

  refreshListing(page: number) {
    console.log(this.freelancerFilter);
    this.freelancerStore.changeFilters(this.freelancerFilter, this.requirement, page, this.maxCandidates);
  }

  openCV(selectedIndex) {
    this.dialog.open(SliderCvComponent, {
      data: {selected: selectedIndex, filters: this.freelancerFilter, requirement: this.requirement}
    });
  }

  onInvite(userId) {
    this.openDialogJobSelectorDialog(userId);
  }

  openDialogJobSelectorDialog(userId) {
    // let dialogRef = this.dialog.open(JobSelectorDialogComponent);
    // dialogRef.componentInstance.createInvite=true;
    // dialogRef.componentInstance.UserID=userId;
    // dialogRef.componentInstance.nameComponent='Invitación';

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('result:' + result);
    // });
  }

  onPostInviteById(id) {
    // const invitations = [{
    //     "job_id":this.jobId,
    //     "user_id":id}];

    // this.inviteService.postInvite(invitations)
    //   .subscribe(
    //     data => {
    //       console.log('invited:done');
    //       this.dialog.open(MessageBoxInviteDialog, {data: {data: data, success: true, showIcon:true}});
    //     },
    //     error => {
    //       console.log('invited:'+error);
    //       this.dialog.open(MessageBoxDialog, {data: {title: 'Información Gastronomy Hunters', message: error.message,
    // alert: true, showIcon: true}});
    //     }
    //   );
  }

  onAsignFreelancer(company_user_id, jobId) {
    console.log('onAsignFreelancer' + company_user_id + ':' + jobId);
    this.freelancerService.postFreelancerAsingOffer(jobId, company_user_id)
    .subscribe(
      data => {
        console.log('Apply:done');
        this.dialog.open(MessageBoxDialog, {data: {title: 'Información Gastronomy Hunters', message: 'Freelancer Asignado Satisfactoriamente', info: true, showIcon: true}});
        this.refreshFreelancerList.emit(true);
      },
      error => {
        console.log('invited:'+error);
        this.dialog.open(MessageBoxDialog, {data: {title: 'Información Gastronomy Hunters', message: error.message, info: true, showIcon: true}});
      }
    );
  }

  onReAsignFreelancer(company_user_id, jobId) {
    console.log('onAsignFreelancer' + company_user_id + ':' + jobId);
    this.freelancerService.putFreelancerAsingOffer(jobId, company_user_id)
    .subscribe(
      data => {
        console.log('Apply:done');
        this.dialog.open(MessageBoxDialog, {data: {title: 'Información Gastronomy Hunters', message: 'Freelancer Asignado Satisfactoriamente', info: true, showIcon: true}});
        this.refreshFreelancerList.emit(true);
      },
      error => {
        console.log('invited:'+error);
        this.dialog.open(MessageBoxDialog, {data: {title: 'Información Gastronomy Hunters', message: error.message, info: true, showIcon: true}});
      }
    );
  }

}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/list-freelancers/list-freelancers.component.ts